import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { buildPageHead } from "@/lib/seo";
import BlogPost from "@/pages/BlogPost";

// Metrics posts live directly under /metrics/{postSlug}.
export const Route = createFileRoute("/metrics/$postSlug")({
  // The library dataset and JSON-LD builder are imported lazily so they
  // stay out of the entry bundle; only the small head fields are returned
  // (they get serialized into the SSR payload).
  loader: async ({ params }) => {
    const [{ getPostBySlug }, { buildLibraryPostJsonLd }] = await Promise.all([
      import("@/data/library"),
      import("@/lib/librarySchema"),
    ]);
    const match = getPostBySlug(params.postSlug);
    if (!match) throw notFound();
    const { post } = match;
    // A post that lives elsewhere 301s to its real home.
    if (post.href !== `/metrics/${post.slug}`) {
      throw redirect({ href: post.href, statusCode: 301 });
    }
    return {
      title: post.seoTitle ?? `${post.title} | Bigdelta`,
      description: post.seoDescription ?? post.dek,
      path: post.href,
      jsonLd: buildLibraryPostJsonLd(post),
    };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    return buildPageHead({
      title: loaderData.title,
      description: loaderData.description,
      path: loaderData.path,
      ogType: "article",
      jsonLd: loaderData.jsonLd,
    });
  },
  component: MetricsPost,
});

function MetricsPost() {
  const { postSlug } = Route.useParams();
  return <BlogPost postSlug={postSlug} />;
}
